export async function onHydrationEnd() {
	// console.log("The page is now interactive!");
}
